<template>
    <div class="house-management parent-frame" :class="{'fixed': listIsFixed}" v-bind:style="{'min-height': myHeight}">
        <transition name="fade"> 
            <alart-msg :display="alart" styleType="success" @alartStatus="closeAlart">
                <span class="title" slot="title">房源新增成功</span>
            </alart-msg>
        </transition>  
        <div class="tool-bar-mask"></div>
        <house-filter :isOpen="houseFilter" @filterClose="closeFilterMenu" @changeFilter="setFilterQuery"></house-filter>
        <Breadcrumb />
        <h1>房源管理</h1>
        <div class="btn-group">
            <drop-menu refName="kk" dropMenuMsg="更多功能" border="1px solid #ff9275" bgColor="#ff9275" arrowColor="white">
                <ul>
                    <router-link :to="{ name: 'batchUpload'}">
                        <li data-id="1">
                            <img src="../../../assets/img/icon/plus_gray.svg" alt="">
                            批量刊登廣告
                        </li>
                    </router-link>
                    <router-link :to="{ name: 'addhouse'}">
                        <li data-id="2">
                            <img src="../../../assets/img/icon/plus_gray.svg" alt="">
                            刊登廣告
                        </li>
                    </router-link>
                </ul>
            </drop-menu>
            <table-search @changeWord="setFilterWord" :setDefault="filterWordIsEmpty"></table-search>
            <div class="filter" @click="openFilter()">
                <img src="../../../assets/img/icon/filter_white.svg" alt="">
            </div>
        </div>
        <tabs :key="componentKey">
            <tab name="全部" :selected="selected.all" >
                <house-mgt-list state="0"></house-mgt-list>
            </tab>
            <tab name="已租" :selected="selected.rented" >
                <house-mgt-list state="1"></house-mgt-list>
            </tab>
            <tab name="未租" :selected="selected.empty" >
                <house-mgt-list state="2"></house-mgt-list>
            </tab>
            
        </tabs>
    </div>
</template>
<script>
import Tabs from '@/components/widge/Tabs.vue';
import Tab from '@/components/widge/Tab.vue';
import DropMenu from '@/components/widge/DropMenu.vue';
import Breadcrumb from '@/components/widge/Breadcrumb.vue';
import TableSearch from '@/components/widge/TableSearch.vue';
import HouseFilter from '@/components/landlord/houseStatus/houseManagement/HouseFilter.vue';
import HouseMgtList from '@/components/landlord/houseStatus/houseManagement/HouseMgtList.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import { mapGetters } from 'vuex'

export default {
    name: 'HouseManagement',
    data () {
        return {
            houseFilter: false,
            listIsFixed: false,
            alart: false,
            myHeight: (window.innerHeight - 84) + 'px',
            selected: {
                all: false,
                rented: false,
                empty: false,
            },
            componentKey: 0,
        }
    },
    created (){
        this.selectTabByHash()
    },
    mounted () {
        console.log('房源管理')
        this.$analytics.logEvent('房源管理', { screen_name: '房源管理'})
        if( this.$route.query.success && this.$route.query.success == 1){
            this.alart = true
            this.$router.replace('/landlord/housemgt/home')
        }
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        $route:{
            handler: function (val) {
                this.forceUpdate()
            },
            // immediate: true,
            deep: true
        }
    },
    methods: {
        selectTabByHash: function () {
            let hashTag = decodeURIComponent(this.$route.hash)
            if( hashTag == '#全部' ){
                console.log('房源管理_全部')
                this.$analytics.logEvent('房源管理_全部', { screen_name: '房源管理_全部'})
                this.selected.all = true
            }else if( hashTag == '#已租' ){
                console.log('房源管理_已租')
                this.$analytics.logEvent('房源管理_已租', { screen_name: '房源管理_已租'})
                this.selected.rented = true
            }else if( hashTag == '#未租' ){
                console.log('房源管理_未租')
                this.$analytics.logEvent('房源管理_未租', { screen_name: '房源管理_未租'})
                this.selected.empty = true
            }else{
                console.log('房源管理_全部')
                this.$analytics.logEvent('房源管理_全部', { screen_name: '房源管理_全部'})
                this.selected.all = true
            }
        },
        closeFilterMenu: function (value) {
            this.houseFilter = value
            this.$store.commit('modalStatus/set_filter_mode', false)
        },
        setFilterQuery: function (value) {
            this.$store.dispatch('setHouseMgtFilterQuery', value)
        },
        setFilterWord: function (value) {
            this.$store.dispatch('setHouseMgtFilterWord', value)
        },
        handleScroll: function () {
            if(!this.isModalMode){
                let scrollTop = event.target.documentElement.scrollTop
                // console.log(scrollTop)
                if( scrollTop >= 50){
                    document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'none'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                }else{
                    document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                    this.listIsFixed = false
                }

                if( scrollTop >= 115){
                    this.listIsFixed = true
                }
            }
        },
        openFilter: function () {
            this.houseFilter = true
            this.$store.commit('modalStatus/set_filter_mode', true)
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
        },
        closeAlart: function () {
            this.alart = false
        },
        setSelectTabAllFalse: function () {
            this.selected.all = false
            this.selected.rented = false
            this.selected.empty = false
            
        },
        forceUpdate: function () {
            this.setSelectTabAllFalse()
            this.selectTabByHash()
            this.componentKey += 1; 
        }
    },
    computed: {
        ...mapGetters({
            filterWordIsEmpty: 'GET_HOUSE_MGT_FILTER_WORD_IS_EMPTY',
            isModalMode: 'GET_MODAL_MODE'
        })
    },
    components: {
        Tabs,
        Tab,
        DropMenu,
        AlartMsg,
        Breadcrumb,
        TableSearch,
        HouseFilter,
        HouseMgtList
    }
}
</script>
<style lang="scss">
    .house-management{
        position: relative;
        margin-top: 42px;
        > h1{
            margin-top: 26px;
            margin-bottom: 40px;
            font-size: 28px;
        }
        .btn-group{
            position: absolute;
            display: flex;
            align-items: center;
            top: 30px;
            right: 20px;
            .drop-menu{
                padding: 12px 14px 12px 24px;
                height: 18px;
                margin-right: 16px;
                span{
                    font-weight: 500;
                    color: #fff;
                }
                ul{
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    width: 187px;
                    right: 0px;
                    li{
                        img{
                            width: 20px;
                            height: 20px;
                            margin-right: 15px;
                        }
                    }
                }
            }
          
            .filter{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 44px;
                height: 44px;
                cursor: pointer;
                background: #a8a5a4;
                border-radius: 4px;
                margin-left: 16px;
            }
        }
        .tabs{
            position: absolute;
            top: 30px;
            left: 150px;
            ul li.is-active :after{
                bottom: -4px;
            }
        }
    }
    .house-management.fixed{
        .tool-bar-mask{
            position: fixed;
            width: 1253px;
            background: #fff;
            height: 80px;
            top: 0px;
            z-index: 7;
            margin-left: -39px;
            border-bottom: 1px solid #f0f0f0;
        }
        h1{
            display: none;
            position: fixed;
            top: 14px;
            z-index: 8;
        }
        .btn-group{
            position: fixed;
            top: 18px;
            right: unset;
            z-index: 8;
            margin-left: 727px;
        }
        .tabs{
            position: fixed;
            margin-left: 0px;
            top: 27px;
            left: unset;
            z-index: 8;
        }
        .tabs-details{
            position: relative;
            padding-top: 59px;
            border-radius: 0 0 10px 10px;
        }
    }
    @media screen and (max-width: 1280px) {
        .house-management{
            .btn-group{
                right: 34px;
            }
        }
        .house-management.fixed{
            .tool-bar-mask{
                width: 100%;
                margin-left: -24px;
            }
            .btn-group{
                margin-left: 714px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/HouseManagementPages/HouseManagementDefault.vue